import { Component, OnInit, Input } from '@angular/core';
import { DomSanitizer, SafeStyle } from '@angular/platform-browser';
import { environment } from '../../../environments/environment';
import { Utils } from '../../common/utils';

@Component({
  selector: 'app-event-message',
  templateUrl: './event-message.component.html',
  styleUrls: ['./event-message.component.scss']
})
export class EventMessageComponent implements OnInit {
  utils = Utils;
  _event: any;
  @Input()  get event(): any { return this._event; }
            set event(event: any) {
              this._event = event;
              if (this._event && this._event.player && this._event.team) {
                this._event.player.image = this.sanitizer.bypassSecurityTrustStyle(
                  `url(${ environment.teamAssetsUrl }/${ this._event.team.code.toLowerCase() }/${ this._event.player.id }.jpg)`
                );
                this._event.team.image = this.sanitizer.bypassSecurityTrustStyle(
                  `url(${ environment.teamAssetsUrl }/${ this._event.team.code.toLowerCase() }/badge.png)`
                );
              }
            }

  constructor(
    private sanitizer: DomSanitizer
  ) { }

  ngOnInit() {
  }

}
